import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {
  GetDeliverySlotsByAdress,
  setCurrentStep,
  setDeliveryInfo,
  getDeliverySimPrice,
  createOrgSimOrder,
} from '../../TransferOrganizationAccountSlice';
import DateTimeSlots from '../../../../Shared/DateTimeSlots/DateTimeSlots';
import {connect} from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {TransferAccountStep, DWHMessageText, DwhActionType, DWHStatus} from '../../Constant/Constant';
import Checkbox from '../../../../Shared/CheckBox/Checkbox';
import {convertToDateTime} from '../../../../../utilities/dateUtils';
import {dwhGeneralReport} from '../../Reports/dwhReports';

const DeliveryTimeSlots = (props) => {
  const [data, setData] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedHours, setSelectedHours] = useState(null);
  const [leaveTheSimInPoBox, setLeaveTheSimInPoBox] = useState(false);
  const SimInPoBoxTxt = 'השאירו את ה-SIM בתיבת הדואר';
  const deliveryAdress = props.deliveryInfo.street + ' ' + props.deliveryInfo.houseNum + ', ' + props.deliveryInfo.city;

  useEffect(() => {
    window.scrollTo(0, 0);
    getDeliverySlots();
    if (!props.price.deliveryPrice) {
      getDeliveryPrice();
    }
    dwhGeneralReport({
      data: {...props.data, selectedHetPay: props.selectedHetPay, userDetails: props.userDetails},
      status: DWHStatus.Ongoing,
      messageText: DWHMessageText.ChooseDeliveryTimeDisplayed,
      actionType: DwhActionType.ChooseDeliveryTime,
    });
  }, []);

  const getDeliveryPrice = async () => {
    await props.getDeliverySimPrice(props.selectedHetPay);
  };

  const getDeliverySlots = async () => {
    const res = await props.GetDeliverySlotsByAdress({
      city: props.deliveryInfo.city,
      street: props.deliveryInfo.street,
      homeNum: props.deliveryInfo.houseNum,
    });
    setData(res?.payload);
  };
  const goToNextPage = async () => {
    props.setDeliveryInfo({
      ...props.deliveryInfo,
      notes: props.deliveryInfo.notes + ' ' + (leaveTheSimInPoBox ? SimInPoBoxTxt : ''),
      startDate: convertToDateTime(selectedDay.date, selectedHours.startHour),
      endDate: convertToDateTime(selectedDay.date, selectedHours.endHour),
      round: selectedHours.round,
      pickLocation: selectedHours.pickLocation,
    });
    await props.createOrgSimOrder();
  };

  return (
    <div className='deliveryContainer'>
      <p className='L_Title'> מתי לשלוח את ה-SIM? </p>
      <p className='M_Title'>
        שליח {window.Config.brand_Name_HE} יגיע לכתובת: {deliveryAdress} <br />
        במידה ותרצו לשנות את כתובת המשלוח
        <div className='underline' onClick={() => props.setCurrentStep(TransferAccountStep.DeliveryPersonalInfo)}>
          לחצו כאן
        </div>
      </p>
      <p className='sec_m_top textWithIcon S_Title'>
        <Image src={require('../../icons/light.svg')} />
        {props.price.deliveryPrice > 0 ? (
          <>
            עלות המשלוח &nbsp;<span className='bold'> ₪{props.price.deliveryPrice} </span>
          </>
        ) : (
          <>המשלוח ללא עלות נוספת</>
        )}
      </p>
      <p className='textWithIcon S_Title'>
        <Image src={require('../../icons/info.svg')} /> אנחנו נעדכן את המנוי בזמן המשלוח שנבחר
      </p>
      {data && (
        <DateTimeSlots
          dateTimeList={data}
          selectedDay={selectedDay}
          setSelectedDay={setSelectedDay}
          selectedHours={selectedHours}
          setSelectedHours={setSelectedHours}
          maxItemToDisplay={3}
        />
      )}
      <div className='checkBox'>
        <Checkbox
          id='terms-checkbox'
          onCheck={() => setLeaveTheSimInPoBox(true)}
          onUncheck={() => setLeaveTheSimInPoBox(false)}
          checked={leaveTheSimInPoBox}>
          <span className='S_Title'> {SimInPoBoxTxt}</span>
        </Checkbox>
      </div>

      <BtnSubmit text={'ליצירת הזמנה'} onclick={() => goToNextPage()} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  deliveryInfo: state.TransferOrganizationAccount.deliveryInfo,
  price: state.TransferOrganizationAccount.price,
  data: state.TransferOrganizationAccount,
  selectedHetPay: state.portalsBlock.selectedHetPay,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  GetDeliverySlotsByAdress,
  getDeliverySimPrice,
  setCurrentStep,
  setDeliveryInfo,
  createOrgSimOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryTimeSlots);
